import React from "react"
import styled, { css } from "styled-components"
import Modal from "./Modal"
import Tag from "buoy-tag"
import { RoundLinkButton } from "buoy-button"
import { colors } from "buoy-theme"
import { Paragraph } from "buoy-text"
import { Link } from "buoy-core"

// NOTE: this modal is going to be removed very soon
// created quickly to meet requirements from state

const CovidModalWrapper = styled.div`
  position: relative;
`

const ContentWrapper = styled.div`
  display: flex;
  @media (max-width: 600px) {
    flex-direction: column;
  }
  height: 100%;
`
const MainHeading = styled.div`
  // margin media queries
  margin: 5px 8px 0 18px;
  @media (min-width: 600px) and (max-width: 1100px) {
    margin: 10px 12px 0 18px;
  }
  @media (max-width: 600px) {
    margin: 5px 14px;
  }
  // font size media queries
  @media (min-width: 600px) {
    font-size: 36px !important;
  }
  @media (max-width: 600px) and (min-width: 450px) {
    font-size: 24px;
  }
  @media (max-width: 450px) {
    font-size: 20px;
  }
`
const ImageWrapper = styled.div`
  // desktop
  width: 50%;
  //   tablet
  @media (min-width: 600px) and (max-width: 1100px) {
    width: 35%;
    height: 100%;
  }
  //   mobile
  @media (max-width: 600px) {
    width: 100%;
    height: 30%;
    margin-bottom: 10px;
  }
  background-image: url("../../../images/covid19.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;
  min-height: 100px;
`

const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  // tablet
  @media (min-width: 600px) and (max-width: 1100px) {
    width: 65%;
  }
  // mobile
  @media (max-width: 600px) {
    width: 100%;
  }
  @media only screen and (device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) {
    padding: 0 5px;
  }
  // iphone 11 pro/X/Xs
  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    padding: 0 5px;
  }
  overflow: scroll;
`

const TagWrapper = styled.div`
  max-width 200px;
  width: 40%;
  margin: 20px 0 0 18px;
  @media (max-width: 600px) {
      display: none;
  }
`

const MobileTagWrapper = styled.div`
  max-width 150px;
  margin: 20px 0 20px 15px;
  @media (min-width: 600px) {
      display: none;
  }
`

const ButtonWrapper = styled.div`
  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
  align-self: center;
  width: 95%;
  @media (max-width: 600px) {
    margin: 10px auto 0 auto;
    width: 92.5%;
  }
  @media (max-width: 400px) {
    margin: 0 auto 0 auto;
    width: 98%;
  }
`

const MainButtonWrapper = styled.div`
  @media (min-width: 600px) {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
  }
`

const ParagraphWrapper = styled.div`
  text-align: center;
`

const LinkWrapper = styled.div`
  text-align: center;
  margin: 15px auto;
`

const Separator = styled.span`
  width: 10px;
`
const HorizontalDivider = styled.hr`
  width: 90%;
  height: 2px;
  background-color: ${colors.neutralLighter};
  align-self: center;
`

const MA_COVID_URL = "https://www.buoyhealth.com/symptom-checker/?configuration=ma_covid&concern=coronavirus"
const VA_COVID_URL = "https://www.buoyhealth.com/symptom-checker/?configuration=va_covid&concern=coronavirus"
const SCF_URL = "https://www.buoyhealth.com/symptom-checker/?concern=coronavirus"
const COVID_CONTENT_URL = "https://www.buoyhealth.com/diagnoses-a-z/coronavirus"

const CovidModal = ({ handleModalClose }) => (
  <CovidModalWrapper style={{ height: "100%" }}>
    <Modal
      covidModal={true}
      showSubmit={false}
      showCancel={false}
      closeOnOutsideClick={true}
      handleModalClose={handleModalClose}
    >
      <ContentWrapper>
        <MobileTagWrapper>
          <Tag tagColor="#db0000">COVID-19 ALERT</Tag>
        </MobileTagWrapper>
        <ImageWrapper></ImageWrapper>

        <MainContentWrapper>
          <TagWrapper>
            <Tag tagColor="#db0000">COVID-19 ALERT</Tag>
          </TagWrapper>

          <MainHeading>
            Coronavirus prevention & treatment: You're in the right place
          </MainHeading>
          <HorizontalDivider />
          <ParagraphWrapper>
            <Paragraph style={{ "font-weight": "500" }}>
              Check for COVID-19 symptoms in:
            </Paragraph>
          </ParagraphWrapper>

          <ButtonWrapper>
            <MainButtonWrapper>
              <RoundLinkButton
                href={MA_COVID_URL}
                target="_blank"
                onClick={() => window.open(MA_COVID_URL, "_blank")}
                covidModal={true}
              >
                Massachusetts (EN/ES)
              </RoundLinkButton>
              <Separator />
              <RoundLinkButton
                href={VA_COVID_URL}
                target="_blank"
                onClick={() => window.open(VA_COVID_URL, "_blank")}
                covidModal={true}
              >
                Virginia (EN/ES)
              </RoundLinkButton>
            </MainButtonWrapper>
            <RoundLinkButton
              backgroundColor="neutralLightest"
              textColor="primary"
              href={SCF_URL}
              target="_blank"
              onClick={() => window.open(SCF_URL, "_blank")}
              covidModal={true}
              secondary={true}
            >
              All other states (EN only)
            </RoundLinkButton>
          </ButtonWrapper>

          <LinkWrapper>
            <Link href={COVID_CONTENT_URL} target="_blank">
              Learn about COVID-19
            </Link>
          </LinkWrapper>

        </MainContentWrapper>
      </ContentWrapper>
    </Modal>
  </CovidModalWrapper>
)

export { CovidModal as default }



// WEBPACK FOOTER //
// ./src/components/ModalOverlay/CovidModal.js